
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Delete Icon","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.168 21.905"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 26082","d":"M3.423 21.906a2.054 2.054 0 01-2.054-2.053V6.679h16.43v13.174a2.053 2.053 0 01-2.054 2.053zM.685 4.859C.307 4.859 0 3.802 0 3.424v-1.37a.684.684 0 01.685-.684H5.82l.4-.8a1.013 1.013 0 01.916-.569h4.89a1.025 1.025 0 01.92.569l.4.8h5.135a.684.684 0 01.684.684v1.37c0 .378-.306 1.435-.684 1.435z","fill":"#243782"}})])
          )
        }
      }
    